import React, { useCallback } from "react";

import { FILTER_COUNT_MAX } from "../../../../constants/form";

import { IFilterMeta, IFilterValue, OperatorType } from "../../../../types/form-type";
import { ITableColumn } from "../../../../types/table-type";

import AddButton from "./Form/AddButton";
import Item from "./Form/Item";

import { FILTER_TYPE_MAP, getDefaultFilterItemValue } from "../../../../utils/filter_main";

import { Container } from "./styled";

interface IProps {
  id: string;
  value: IFilterMeta;
  onChange: (data: any) => void;
  options: ITableColumn[];
  shareUserId: string;
}

const Filter: React.FC<IProps> = ({
  id,
  value = { filterValues: [], operatorType: OperatorType.AND },
  onChange,
  options,
  shareUserId,
}) => {
  const { filterValues, operatorType } = value;

  const handleAddFilter = useCallback(() => {
    const newValue = {
      operatorType: operatorType,
      filterValues: [...filterValues, getDefaultFilterItemValue(options)],
    };

    onChange({ [id]: newValue });
  }, [id, onChange, options, filterValues, operatorType]);

  const handleRemoveItem = useCallback(
    (index) => {
      const newValue = {
        operatorType: operatorType,
        filterValues: filterValues.filter((item, index2) => index2 !== index),
      };
      onChange({ [id]: newValue });
    },
    [id, onChange, filterValues, operatorType]
  );

  const handleOperatorChange = useCallback(
    (value: OperatorType) => {
      const newValue = {
        filterValues,
        operatorType: value,
      };
      onChange({ [id]: newValue });
    },
    [id, onChange, filterValues]
  );

  const handleValueChange = useCallback(
    (value: IFilterValue, index: number) => {
      let newFilterValues = [...filterValues];
      newFilterValues[index] = value;
      const newValue = {
        operatorType,
        filterValues: newFilterValues,
      };
      onChange({ [id]: newValue });
    },
    [filterValues, operatorType, id, onChange]
  );

  return (
    <Container>
      {filterValues.map((item, index) => (
        <Item
          {...item}
          index={index}
          onRemove={handleRemoveItem}
          value={filterValues[index]}
          columnOptions={options}
          column={options.find((item) => item.id === filterValues[index].columnId)}
          operatorType={operatorType}
          onOperatorChange={handleOperatorChange}
          onValueChange={handleValueChange}
          shareUserId={shareUserId}
        />
      ))}
      {filterValues.length < FILTER_COUNT_MAX && <AddButton add={handleAddFilter} />}
    </Container>
  );
};

export default Filter;
